module.exports = __webpack_public_path__ + "img/culture_item2.f09b9cbf.png";